import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#FF0000', 
    },
    secondary: {
      main: '#ff9e80',
    },
  },
});
